<h1 mat-dialog-title>MF Contacts: {{data.subdivision_name}}</h1>

<div mat-dialog-content class="mf-contacts">

  <div class="mf-add-row">
    <mat-form-field class="mf-search">
      <mat-label>Add a contact (search by name)</mat-label>
      <input matInput [formControl]="searchControl" [matAutocomplete]="contactAuto" placeholder="Type at least 2 letters">
    </mat-form-field>
    <mat-autocomplete #contactAuto="matAutocomplete" [displayWith]="displayBlank" (optionSelected)="addContact($event.option.value)">
      <mat-option *ngFor="let c of (search$ | async)" [value]="c">
        <span class="mf-opt-name">{{c.name}}</span>
        <span class="mf-opt-meta">{{c.customer_name || 'no builder'}}<span *ngIf="c.email"> &middot; {{c.email}}</span></span>
      </mat-option>
    </mat-autocomplete>
    <mat-checkbox [formControl]="builderOnly" [disabled]="!data.customer_id" class="mf-builder-only">
      {{data.customer_name || 'This builder'}} only
    </mat-checkbox>
  </div>

  <p *ngIf="loading" class="mf-hint">Loading contacts...</p>
  <p *ngIf="!loading && rows.length === 0" class="mf-hint">No MF contacts yet. Search above to add one.</p>

  <table class="mf-table" *ngIf="rows.length > 0">
    <thead>
      <tr>
        <th>Contact</th>
        <th>Builder</th>
        <th>Email / Phone</th>
        <th>Contact Type</th>
        <th>Rank</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; let i = index">
        <td>
          {{row.name}}
          <div *ngIf="row.missing" class="mf-flag">Contact no longer exists - remove this row</div>
          <div *ngIf="row.inactive && !row.missing" class="mf-flag">Inactive contact</div>
        </td>
        <td>{{row.customer_name || '-'}}</td>
        <td class="mf-meta">
          <div>{{row.email || '-'}}</div>
          <div>{{row.phone || '-'}}</div>
        </td>
        <td>
          <mat-form-field class="mf-type" floatLabel="never">
            <mat-select aria-label="Contact type" placeholder="Select type" [value]="row.contact_type" (selectionChange)="setType(row, $event.value)">
              <mat-option *ngFor="let t of types" [value]="t">{{t}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="isDuplicate(row)" class="mf-flag">Already listed with this type</div>
        </td>
        <td>
          <mat-form-field class="mf-rank" floatLabel="never">
            <mat-select aria-label="Rank" placeholder="None" [value]="row.rank || ''" (selectionChange)="setRank(row, $event.value)">
              <mat-option value="">-- None --</mat-option>
              <mat-option *ngFor="let r of ranks" [value]="r">{{r}}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <button mat-icon-button type="button" color="warn" title="Remove" (click)="removeRow(i)">
            <fa-icon [icon]="faTrashAlt"></fa-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <p *ngIf="untypedCount > 0" class="mf-flag">Every contact needs a type before saving.</p>
  <p *ngIf="!loading && !isBillingBldg" class="mf-hint">
    This subdivision is not a billing building (no location with "billing" in its lot), so the Extra Notes contact post is not maintained for it.
  </p>
</div>

<div mat-dialog-actions>
  <button mat-button type="button" (click)="close()">Close</button>
  <button mat-button type="button" [disabled]="!canSave" (click)="save()" cdkFocusInitial>Save</button>
</div>
